<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id,
        status
      }"
    />
    <Multiselect
      :id="id"
      ref="multiselect"
      :value="value"
      :customLabel="customLabel"
      :placeholder="disabled ? '—' :(placeholder || `Type to search for ${ $localize('course set', 'plural') }`)"
      openDirection="bottom"
      :options="selectOptionsFiltered"
      :loading="isLoading"
      :internalSearch="false"
      :limitText="limitText"
      :showNoOptions="true"
      :showNoResults="true"
      :multiple="config.multiple"
      class="mb-2"
      :disabled="disabled"
      @input="update"
      @search-change="asyncFind"
    >
      <template slot="noOptions">
        Search to find {{ $localize('course set', 'plural') }}.
      </template>
      <template slot="noResult">
        No {{ $localize('course set', 'plural') }} found.
      </template>
    </Multiselect>
  </div>
</template>
<script>
import FormMixin from './FormMixin'
import { mapGetters } from 'vuex'
import { getCmCourseSetsSearch } from '@/api'
import _debounce from 'lodash/debounce'
import Multiselect from '@/components/Multiselect'
import { DEBOUNCE_INTERVAL } from '@/constants/'
import FormLabel from './FormLabel'

export default {
  mixins: [ FormMixin ],
  components: { Multiselect, FormLabel },
  props: {
    excludedIds: {
      type: Array,
      default: () => ([]),
    },
    includedIds: {
      type: Array,
      default: () => ([]),
    },
    config: {
      type: Object,
      default: () => ({
        multiple: true,
      }),
    },
  },
  data () {
    return {
      selectOptions: [],
      isLoading: false,
      searchQuery: null,
    }
  },
  computed: {
    ...mapGetters([ 'school' ]),
    ...mapGetters('curriculumCourses', [ 'courseSetById' ]),
    searchConfig () {
      return {
        school: this.school,
        searchQuery: this.searchQuery,
        ...(this.config.includeAggregatedCoursesData ? { includeAggregatedCoursesData: true } : {}),
      }
    },
    selectOptionsFiltered () {
      return this.selectOptions
        .filter(courseSetId => !this.excludedIds.includes(courseSetId))
        .filter(courseSetId => !this.includedIds.length || this.includedIds.includes(courseSetId))
    },
  },
  methods: {
    limitText (count) {
      return `and ${count} other course sets`
    },
    customLabel (value) {
      const courseSet = this.courseSetById(value)
      return courseSet?.name || 'Untitled Course Set'
    },
    asyncFind (query) {
      if (query) {
        this.isLoading = true
        this.getCourseSetsDebounced(query)
      } else {
        this.isLoading = false
      }
    },
    getCourseSetsDebounced: _debounce(function (query) {
      this.getCourseSets(query)
    }, DEBOUNCE_INTERVAL),
    getCourseSets (query) {
      this.searchQuery = query
      getCmCourseSetsSearch(this.searchConfig).then(({ data = [], aggregatedCoursesData = [] }) => {
        this.selectOptions = data.map(el => {
          this.$store.commit('curriculumCourses/setCourseSet', {
            ...(aggregatedCoursesData.find(data => data.id === el.id) || {}),
            ...el,
          })
          return el.id
        })
        this.isLoading = false
      })
    },
  },
}
</script>

<style scoped>
.form-control {
  height: 36px;
}
.multiselect >>> .multiselect__tag {
  white-space: normal;
}
.multiselect >>> .multiselect__tags {
  overflow: hidden;
}
</style>
